module.exports = __webpack_public_path__ + "img/bg_hexagon_blue_mobile.9f40f374.png";